// Who waits for which change queue upload pass (BUG-2111). The sync engine runs one pass at a time,
// so passes are numbered, and a back-online re-read waits for the next one to start.

/** The engine's upload-pass bookkeeping. */
export interface UploadPassWaiters {
  /** Number the pass that starts now. @returns its number. */
  start(): number;
  /** @returns once the next pass to start has finished. */
  next(): Promise<void>;
  /** Release everyone waiting for pass `upTo` or an earlier one; `Infinity` releases them all. */
  settle(upTo: number): void;
}

/** @returns an empty set of waiters. */
export function createUploadPassWaiters(): UploadPassWaiters {
  let started = 0;
  let waiters: Array<{ pass: number; resolve: () => void }> = [];
  return {
    start: () => ++started,
    next: () => new Promise((resolve) => waiters.push({ pass: started + 1, resolve })),
    settle: (upTo) => {
      const ready = waiters.filter((waiter) => waiter.pass <= upTo);
      waiters = waiters.filter((waiter) => waiter.pass > upTo);
      for (const waiter of ready) waiter.resolve();
    },
  };
}
